// The last data we loaded from the server, kept on this phone so the app opens instantly
// and still works with no signal (read-only). Written after every successful load or sync,
// deleted on sign-out. Raw email text is left out; everything else is what we already show.

import type { AppState } from './state.ts';

const KEY = 'natangelo:snapshot';
/** Bump when AppState changes shape in a way old copies can't be read as. */
const VERSION = 1;

export interface Snapshot {
  state: AppState;
  /** When this copy was last confirmed against the server (ISO). */
  savedAt: string;
}

interface Stored extends Snapshot {
  version: number;
}

export function loadSnapshot(storage: Storage | undefined): Snapshot | undefined {
  try {
    const raw = storage?.getItem(KEY);
    if (!raw) return undefined;
    const s = JSON.parse(raw) as Stored;
    if (s.version !== VERSION || !s.state || !s.savedAt) return undefined;
    return { state: s.state, savedAt: s.savedAt };
  } catch {
    return undefined;
  }
}

export function saveSnapshot(storage: Storage | undefined, state: AppState, savedAt: string): void {
  try {
    const slim: AppState = { ...state, emails: state.emails.map(({ bodyPreview: _drop, ...e }) => e) };
    storage?.setItem(KEY, JSON.stringify({ version: VERSION, state: slim, savedAt } satisfies Stored));
  } catch {
    // Storage full or unavailable: the app still works online.
  }
}

export function clearSnapshot(storage: Storage | undefined): void {
  try {
    storage?.removeItem(KEY);
  } catch {
    // nothing to clear
  }
}
